<template>
  <div class="extras-mg-forma">
    <div class="extras-mg-forma__etiqueta">Colorear segun el campo</div>
    <Dropdown
      :value="options && options.field_id"
      :disabled="readOnly"
      :show-search="true"
      class="extras-mg-forma__campo"
      @input="elegirCampo"
    >
      <DropdownItem name="Ninguno" :value="null"></DropdownItem>
      <DropdownItem
        v-for="campo in camposDeSeleccion"
        :key="campo.id"
        :name="campo.name"
        :value="campo.id"
      ></DropdownItem>
    </Dropdown>

    <div v-if="!camposDeSeleccion.length" class="extras-mg-forma__aviso">
      Esta tabla no tiene ningun campo de seleccion unica. Crea uno para poder
      colorear las filas por su valor.
    </div>
    <div v-else class="extras-mg-forma__aviso">
      El color de cada fila es el que ya tiene su opcion en el campo elegido.
      Si cambias el color de una opcion, las filas se recolorean solas.
    </div>
  </div>
</template>

<script>
import Dropdown from '@baserow/modules/core/components/Dropdown'
import DropdownItem from '@baserow/modules/core/components/DropdownItem'

export default {
  name: 'FormaColorPorSeleccion',
  components: { Dropdown, DropdownItem },
  props: {
    fields: { type: Array, required: true },
    options: { type: Object, required: false, default: () => ({}) },
    readOnly: { type: Boolean, required: false, default: false },
    view: { type: Object, required: false, default: null },
    table: { type: Object, required: false, default: null },
    database: { type: Object, required: false, default: null },
  },
  computed: {
    camposDeSeleccion() {
      return this.fields.filter((f) => f.type === 'single_select')
    },
  },
  methods: {
    elegirCampo(idCampo) {
      this.$emit('update', { field_id: idCampo })
    },
  },
}
</script>

<style lang="scss">
.extras-mg-forma {
  padding: 8px 12px;
}

.extras-mg-forma__etiqueta {
  font-size: 12px;
  margin-bottom: 6px;
  opacity: 0.75;
}

.extras-mg-forma__aviso {
  font-size: 11px;
  margin-top: 8px;
  opacity: 0.6;
  /* Texto de UI: sin justificar, va en una columna angosta. */
  line-height: 1.4;
}
</style>
